import { render, staticRenderFns } from "./ClientSalesReport.vue?vue&type=template&id=6b48d62d"
import script from "./ClientSalesReport.vue?vue&type=script&lang=js"
export * from "./ClientSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports